module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1025-0cfa6ee1d29828e35564017f56065b8f.png";